import Navbar from '@/components/feature/Navbar';
import ContactFooter from '@/pages/home/components/ContactFooter';
import IntroHero from './components/IntroHero';
import IntroMission from './components/IntroMission';
import IntroStats from './components/IntroStats';
import IntroStrengths from './components/IntroStrengths';
import IntroLocation from './components/IntroLocation';

export default function IntroductionPage() {
  return (
    <div className="min-h-screen w-full">
      <Navbar />
      <main>
        <IntroHero />
        <IntroMission />
        <IntroStats />
        <IntroStrengths />
        <IntroLocation />
      </main>
      <ContactFooter />
    </div>
  );
}
